import {Box, Button, Img, Link} from '@chakra-ui/react';
import {motion} from 'framer-motion';
import * as React from 'react';
import {useEffect, useState} from 'react';
import {ArrowSvg} from '../../../../assets';

const MotionButton = motion(Button);

const PersonBioBanner = ({data}) => {
    const ref = React.useRef();
    const imgWrap = document.getElementById("image-wrap");
    const [topPos, setTopPos] = useState('0')

    useEffect(() => {
        const topPosition = imgWrap?.getBoundingClientRect().top;
        console.log('top position', topPosition);
        if (topPosition) {
            setTopPos(topPosition)
        }
    }, [imgWrap])
    return (
        <Box
            pos={{base: 'relative', lg: 'sticky'}}
            float={{base: 'none', lg: 'right'}}
            // insetY={{lg: '0'}}
            // insetEnd={{lg: '0'}}
            w={'100%'}
            marginBottom={{base: '20px', lg: 0}}
            maxW={{base: 'full', lg: '50%', xl: '50%'}}
            height={{base: 'full', lg: 'full'}}
            // maxH={{base: 'unset', lg: '780px'}}
            ref={ref}
            id="image-wrap"
            top={{base: 0, lg: topPos}}
            // mb={14}
            zIndex={50}
        >
            <Box position="relative">
                <Img
                    height="100%"
                    width={{base: '100%', lg: 'auto'}}
                    objectFit="cover"
                    src={`${data?.fimg_url}`}
                    alt={`${data?.acf?.first_name} ${data?.acf?.last_name}`}
                    marginLeft={{base: '0', lg: 'auto'}}
                />
                <Link href={data.acf.high_res_download} download={data.acf.author_id.user_nicename} download
                      position={'absolute'}
                      bottom={'20px'}
                      right={'20px'}>
                    <MotionButton
                        zIndex={1}
                        animate={{
                            scale: [1, 2, 2, 1, 1],
                            rotate: [0, 0, 270, 270, 0],
                            // borderRadius: ['20%', '20%', '30%', '20%', '100%'],
                        }}
                        size={'xs'}
                        variant={'solid'}
                        bgColor={'white'}
                        iconSpacing={0}
                        borderRadius={0}
                    >
                        <ArrowSvg/>
                    </MotionButton>
                </Link>
            </Box>
        </Box>
    );
};
export default PersonBioBanner;
